
import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'
import AppConfig from '@/builtConf.json'

let routes = []

AppConfig.appNavigation.routing.forEach(
  (route)=>{
      let children = []
      if(route.children){
        route.children.forEach(
          (child)=>{
            let subChildren = []
            if(child.children){
              child.children.forEach(
                (subChild)=>{
                  subChildren.push(
                    {
                      "path": subChild.path,
                      "name": subChild.name,
                      "props": subChild.props, 
                      "component": require(`../${subChild.component}`).default,       
                      "meta": subChild.meta ,
                      beforeEnter(to, from, next){
                        if(!store.getters["authentication/isLoggedIn"] && to.meta.requiresAuth == true){
                          next({name: "login"})
                        } else {
                          next()
                        }
                      }
                    }
                  )
                }
              )
            }

            children.push(
              {
                "path": child.path,
                "name": child.name,
                "props": child.props, 
                "component": require(`../${child.component}`).default,       
                "meta": child.meta,
                "children": subChildren,
                beforeEnter(to, from, next){
                  if(!store.getters["authentication/isLoggedIn"] && to.meta.requiresAuth == true){
                    next({name: "login"})
                  } else {
                    next()
                  }
                }
              }
            )
          
          }
        )

      }
      routes.push({
        "path": route.path,
        "name": route.name,
        "props": route.props, 
        "component": require(`../${route.component}`).default,       
        "meta": route.meta,
        "children": children,
        beforeEnter(to, from, next){
          if(!store.getters["authentication/isLoggedIn"] && to.meta.requiresAuth == true){
            next({name: "login"})
          } else {
            document.title = to.name.charAt(0).toUpperCase() + to.name.slice(1);
            next()
          }
        }
      })
  }
)



Vue.use(Router)

const router = new Router({
  routes: routes
})


export default router